export default (value) => value && value.constructor === Object;
